import { Typography } from "antd";

function InlineCopyable({ children }) {
  return <Typography.Text copyable>{children}</Typography.Text>;
}

export default InlineCopyable;
